<template>
  <div id="app">
    <notifications position="bottom center" width="54%" />

    <v-app style="background: #ffffff">
      <div class="cs-header">
        <div class="cs-header-content">
          <div class="cs-header-inner-content">
            <div id="cs_img"></div>
          </div>
          <div class="cs-header-inner-content">
            <router-view name="mainmenu"></router-view>
          </div>
          <v-spacer></v-spacer>
          <div class="cs-header-inner-content">
            <div @click="swapLanguage()">
              <img
                :src="require('@/assets/flags/' + languageImg + '.svg')"
                height="28"
                style="margin-top: 18px"
                class="cs-img-clickable"
              />
            </div>
          </div>
        </div>
      </div>

      <v-content class="cs-content">
        <router-view></router-view>
      </v-content>

      <v-footer height="auto" style="margin-top: 42px; padding: 0px">
        <v-card class="flex" flat tile>
          <v-card-title class="crashstickers-footer-grey">
            <div class="cs-footer-content">
              <div class="cs-footer-inner-content">
                <ul>
                  <li class="cs-footer-nav">
                    <a @click="openTermsAndConditions()">
                      {{ $t('footer.termsAndConditions') }}
                    </a>
                  </li>
                  <li class="cs-footer-nav">
                    <a @click="openlegalDisclaimer()">
                      {{ $t('footer.legalDisclaimer') }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </v-card-title>

          <v-card-actions class="crashstickers-footer-darkblue">
            <div class="cs-footer-content">
              <div class="cs-footer-inner-content">
                <div class="cs-footer-info">
                  <span class="cs-footer-info-firstline">
                    Serverless application made in Belgium by
                    <a href="http://www.rtaconsulting.eu/" target="_rta"
                      >rta Consulting</a
                    >. Version 1.1.0.
                  </span>
                  <br />© All right reserved. No part of this publication may be
                  reproduced or transmitted in any form by any means, or stored
                  in any retrieval system of any nature without prior written
                  permission of Be Genius sprl.
                </div>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'App',

  computed: {
    language: function() {
      return localStorage.getItem('cs-agent-preferredLanguage');
    },
    languageImg: function() {
      const lng = this.language;
      if (lng === 'fr') {
        return 'nl';
      } else {
        return 'fr';
      }
    },
    termsAndConditionUrl: function() {
      const lng = this.language;
      if (lng === 'fr') {
        return 'https://www.crashstickers.com/terms-and-condition.html';
      } else {
        return 'https://www.crashstickers.com/terms-and-condition.html';
      }
    },
    legalDisclaimerUrl: function() {
      const lng = this.language;
      if (lng === 'fr') {
        return 'https://www.crashstickers.com/legal-notice.html';
      } else {
        return 'https://www.crashstickers.com/legal-notice.html';
      }
    },
  },

  methods: {
    openTermsAndConditions() {
      window.open(this.termsAndConditionUrl, '_tc');
    },
    openlegalDisclaimer() {
      window.open(this.legalDisclaimerUrl, '_ld');
    },
    openContact() {
      window.open(this.contactUrl, '_contact');
    },

    swapLanguage() {
      const lng = localStorage.getItem('cs-agent-preferredLanguage');

      let targetlng;
      if (lng === 'fr') {
        targetlng = 'nl';
      } else {
        targetlng = 'fr';
      }

      localStorage.setItem('cs-agent-preferredLanguage', targetlng);
      this.$router.go();
    },
  },
};
</script>

<style>
html,
body {
  font-family: 'Roboto', 'Helvetica', sans-serif;
}
.cs-header {
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 7px 0px;
  box-sizing: border-box;
  color: rgb(102, 102, 102);
  display: block;
  position: fixed;
  top: 0px;
  width: 100%;
  transition-delay: 0s, 0s, 0s, 0s;
  transition-duration: 0.4s, 0.4s, 0.4s, 0.4s;
  transition-property: background-color, color, transform, opacity;
  transition-timing-function: ease, ease, ease, ease-in-out;
  z-index: 99999;
  -moz-osx-font-smoothing: grayscale;
}

.cs-header-content {
  max-width: 900px !important;
  width: 900px;
  margin: auto;
  height: 91px;
  text-align: center;
  display: flex;
}

.cs-header-inner-content {
  margin: auto;
  text-align: center;
}

.cs-content {
  max-width: 900px !important;
  width: 100%;
  margin: auto;
}

.cs-footer-content {
  max-width: 900px !important;
  width: 900px;
  margin: auto !important;
  text-align: left;
  display: flex;
}

.cs-footer-inner-content {
  max-width: 900px !important;
  width: 900px;
  margin: auto;
  text-align: left;
}

.cs-footer-inner-content ul {
  list-style: none;
  padding-left: 0px;
  /* margin-left: -24px; */
}

.cs-footer-inner-content li {
  display: inline-block;
  padding-right: 22px;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}

.cs-footer-nav a {
  opacity: 1;
  outline-color: rgba(0, 0, 0, 0.64);
  outline-style: none;
  outline-width: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
  text-align: left;
  text-decoration: none;
  text-decoration-color: rgba(0, 0, 0, 0.64);
  text-decoration-line: none;
  text-decoration-style: solid;
  transition-delay: 0s;
  transition-duration: 0.4s;
  transition-property: all;
  transition-timing-function: ease-in-out;
  vertical-align: baseline;
  -moz-osx-font-smoothing: grayscale;
  color: rgba(0, 0, 0, 0.64) !important;
  font-size: 16px;
  font-family: 'PT Sans', Helvetica, Arial, Lucida, sans-serif;
  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  font-weight: 600;
  line-height: 27.2px;
  list-style-image: none;
  list-style-position: outside;
  list-style-type: none;
}

.cs-footer-nav a:hover {
  opacity: 0.7;
}

.cs-footer-info {
  float: left;
  padding-top: 8px;
  padding-bottom: 12px;
  color: #666;
  text-align: left;
  color: rgba(255, 255, 255, 0.56);
  float: left;
  font-family: 'PT Sans', Helvetica, Arial, Lucida, sans-serif;
  font-size: 12px;

  font-weight: 500;
  -moz-osx-font-smoothing: grayscale;
}

.cs-footer-info-firstline {
  line-height: 38px;
}

.cs-footer-info a {
  color: rgba(255, 255, 255, 0.56);
  font-weight: 700;
  text-decoration: none;
}

.cs-footer-info a:hover {
  opacity: 0.7;
}

#footer-bottom a {
  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.notification-title {
  font-family: 'Raleway', sans-serif !important;
  font-size: 30px;
  font-style: normal;
  font-weight: 900;
  padding-bottom: 8px;
}

.notification-content {
  font-family: 'Raleway', sans-serif !important;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.45;
  padding-bottom: 4px;
}

.cs-white-background {
  background-color: #ffffff;
}

.cs-page-header {
  padding-right: 24px;
  padding-left: 26px;
}

.cs-component-content {
  padding-right: 4px;
  padding-left: 4px;
}

.cs-form-intro-help {
  font-size: 17px;
}

.cs-form-intro-help-bold {
  font-size: 17px;
  font-weight: bold;
}

.cs-form-color-intro {
  color: #164396;
}

.white-background {
  background-color: #ffffff;
  height: 100%;
}

.crashstickers-header {
  background-color: white;
}

.crashstickers-content-index {
  padding-top: 40px;
}

.crashstickers-gridrow-index {
  padding-top: 60px;
}

.crashstickers-subscribebutton-div {
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  margin-top: 28px;
  padding-top: 36px;
  margin-bottom: 56px;
}

.crashstickers-contact-div {
  margin-top: 28px;
  padding-top: 36px;
  margin-bottom: 56px;
}

.crashstickers-textfield {
  width: 100%;
}

.crashstickers-textfield-container {
  padding-right: 10px;
}

.crashstickers-footer-grey {
  background-color: #d1d1d1 !important;
  border-color: #d1d1d1 !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.crashstickers-footer-darkblue {
  background-color: #1f3e8f !important;
  border-color: #1f3e8f !important;
}

.cs-img-clickable {
  cursor: pointer;
}

@media all and (min-width: 840px) {
  #cs_img {
    background-image: url('./assets/logos/CrashStickers-logo-2018.png');
    background-size: 100px;
    width: 100px;
    height: 63.5px;
  }

  .cs-content {
    margin-top: 98px;
    margin-bottom: 30px;
  }

  .cs-form-intro-large {
    background-color: #ffffff;
    font-family: 'Raleway', sans-serif !important;
    font-size: 36px;
    font-style: normal;
    font-weight: 900;
    line-height: 1.109;
    color: #1976d2;
    margin-bottom: 20px;
  }

  .cs-form-intro-medium {
    background-color: #ffffff;
    font-family: 'Raleway', sans-serif !important;
    font-size: 28px;
    font-style: normal;
    font-weight: 900;
    line-height: 1.09;
    color: #1976d2;
    margin-bottom: 20px;
  }

  .cs-form-intro-small {
    background-color: #ffffff;
    font-family: 'Raleway', sans-serif !important;
    font-size: 30px;
    font-style: normal;
    font-weight: 900;
    line-height: 1.109;
    color: #164396;
  }
}

@media all and (max-width: 839px) {
  .crashstickers-textfield {
    width: 100%;
  }

  #cs_img {
    background-image: url('./assets/logos/CrashStickers-logo-2018.png');
    background-size: 100px;
    width: 100px;
    height: 63.5px;
  }

  .cs-content {
    margin-top: 94px;
    margin-bottom: 26px;
  }

  .cs-form-intro-large {
    background-color: #ffffff;
    font-family: 'Raleway', sans-serif !important;
    font-size: 30px;
    font-style: normal;
    font-weight: 900;
    line-height: 1.109;
    color: #1976d2;
    margin-bottom: 20px;
  }

  .cs-form-intro-medium {
    background-color: #ffffff;
    font-family: 'Raleway', sans-serif !important;
    font-size: 24px;
    font-style: normal;
    font-weight: 900;
    line-height: 1.09;
    color: #1976d2;
    margin-bottom: 20px;
  }

  .cs-form-intro-medium-dark {
    background-color: #ffffff;
    font-family: 'Raleway', sans-serif !important;
    font-size: 24px;
    font-style: normal;
    font-weight: 900;
    line-height: 1.09;
    color: #164396;
    margin-bottom: 20px;
  }

  .cs-form-intro-small {
    background-color: #ffffff;
    font-family: 'Raleway', sans-serif !important;
    font-size: 28px;
    font-style: normal;
    font-weight: 900;
    line-height: 1.109;
    color: #164396;
  }
}
</style>
